import { defineChannel, type ChannelDefinition } from '../channel-definition';

export const smsChannel = defineChannel({
  id: 'sms',
  icon: 'sms',
} as const satisfies ChannelDefinition);
